import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import SportStatisticsStore from "@state/stores/offer/statistics/SportStatisticsStore";
import { observer } from "mobx-react-lite";

import EventArticle from "./EventArticle";
import EventInsights from "./EventInsights";

export const EventInsightsContent = observer(
	function EventInsightsContent(props: { store: SportStatisticsStore }) {
		const { t } = useTranslation();

		const [shouldShowDetails, setShouldShowDetails] = useState<boolean>(
			props.store.eventInsights.length === 0 ? true : false
		);

		const scrollToTopOnDetailsHide = () => {
			const mainContent = document.querySelector(".l--master");

			if (mainContent) {
				mainContent.scrollTo({ top: 0, behavior: "smooth" });
			}
		};

		return (
			<div className="event__content">
				<EventInsights eventInsights={props.store.eventInsights} />

				{props.store.articleInsights ? (
					<>
						{props.store.eventInsights.length > 0 ? (
							<div className="u-type--center">
								<button
									type="button"
									className="btn btn--sml btn--subtle btn--radial--full btn--icon u-type--xsml"
									onClick={() =>
										setShouldShowDetails(!shouldShowDetails)
									}
								>
									{shouldShowDetails
										? t("COMMON.HIDE_FULL_ARTICLE")
										: t("COMMON.SHOW_FULL_ARTICLE")}
									<i
										className={
											"u-icon u-icon--xtny" +
											(shouldShowDetails
												? " u-icon--caret--up"
												: " u-icon--caret--down")
										}
									/>
								</button>
							</div>
						) : null}

						{shouldShowDetails ? (
							<>
								<EventArticle
									store={props.store}
									shouldShowDetails={shouldShowDetails}
								/>

								{props.store.eventInsights.length > 0 ? (
									<div className="u-type--center">
										<button
											type="button"
											className="btn btn--sml btn--subtle btn--radial--full btn--icon u-type--xsml"
											onClick={() => {
												setShouldShowDetails(
													!shouldShowDetails
												);

												scrollToTopOnDetailsHide();
											}}
										>
											{t("COMMON.HIDE_FULL_ARTICLE")}
											<i className="u-icon u-icon--xtny u-icon--caret--up" />
										</button>
									</div>
								) : null}
							</>
						) : null}
					</>
				) : null}
			</div>
		);
	}
);
